import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMenuFilter, toggleFilterSidebar } from '../action';
import { FiX, FiPackage, FiGrid } from 'react-icons/fi';

function FilterSidebar() {
  const dispatch = useDispatch();
  const { categories, filterSidebarOpen } = useSelector(state => state);

  useEffect(() => {
    if (filterSidebarOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [filterSidebarOpen]);

const handleCategoryFilter = (categoryName) => {
  dispatch(getMenuFilter(categoryName));
  
  // Cerrar el sidebar automáticamente después de seleccionar una categoría
  dispatch(toggleFilterSidebar());
};


  const closeSidebar = () => {
    dispatch(toggleFilterSidebar());
  };

  return (
    <>
      {/* Overlay */}
      {filterSidebarOpen && (
        <div 
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-40 transition-opacity duration-300"
          onClick={closeSidebar}
        />
      )}
      
      {/* Sidebar */}
      <div className={`
        fixed top-0 left-0 h-full w-80 bg-white shadow-2xl transform transition-all duration-300 z-50 border-r border-slate-200
        ${filterSidebarOpen ? 'translate-x-0' : '-translate-x-full'}
      `}>
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-slate-200 bg-slate-50">
          <div className="flex items-center space-x-3">
            <div className="p-2 bg-slate-900 rounded">
              <FiGrid className="w-5 h-5 text-white" />
            </div>
            <h2 className="text-xl font-vintage-display font-semibold text-slate-800">Filtros</h2>
          </div>
          <button
            onClick={closeSidebar}
            className="vintage-filter-btn p-2 group"
          >
            <FiX className="w-5 h-5 group-hover:rotate-90 transition-all duration-200" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto h-full pb-20">
          {/* Productos Section */}
          <div className="mb-8">
            <div className="flex items-center space-x-3 mb-6">
              <div className="p-2 bg-slate-900 rounded">
                <FiPackage className="w-5 h-5 text-white" />
              </div>
              <h3 className="text-lg font-vintage-display font-semibold text-slate-800">Categorías</h3>
            </div>
            
            {/* Categorías */}
            <div className="space-y-3">
              <h4 className="vintage-category mb-4">
                Categorías
              </h4>
              
              {/* Todas las categorías */}
              <button
                onClick={() => handleCategoryFilter('all')}
                className="group w-full text-left px-4 py-3 text-sm font-medium text-slate-800 hover:bg-slate-900 hover:text-white rounded transition-all duration-200 flex items-center space-x-3 border border-slate-200"
              >
                <div className="w-2 h-2 bg-slate-600 rounded-full group-hover:bg-white group-hover:scale-125 transition-all duration-200"></div>
                <span>Todos los productos</span>
                <div className="ml-auto opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                  <div className="w-1 h-1 bg-white rounded-full"></div>
                </div>
              </button>
              
              {/* Categorías individuales */}
              <div className="space-y-2">
                {categories.map((category, index) => (
                  <button
                    key={category.id}
                    onClick={() => handleCategoryFilter(category.name)}
                    className="group w-full text-left px-4 py-3 text-sm text-slate-700 hover:bg-slate-900 hover:text-white rounded transition-all duration-200 flex items-center space-x-3 border border-slate-200 transform hover:translate-x-1"
                    style={{
                      animationDelay: `${index * 50}ms`
                    }}
                  >
                    <div className="w-2 h-2 bg-slate-400 rounded-full group-hover:bg-white group-hover:scale-125 transition-all duration-200"></div>
                    <span className="group-hover:font-medium transition-all duration-200">{category.name}</span>
                    <div className="ml-auto opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                      <div className="w-1 h-1 bg-white rounded-full"></div>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* Info Section */}
          <div className="bg-slate-50 rounded p-4 border border-slate-200">
            <div className="flex items-center space-x-2 mb-3">
              <div className="w-2 h-2 bg-slate-700 rounded-full animate-pulse"></div>
              <p className="vintage-category">
                Consejo
              </p>
            </div>
            <p className="text-sm text-slate-600 leading-relaxed">
              Filtra por categoría para encontrar rápidamente lo que tu negocio necesita.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default FilterSidebar;